import React from 'react'
import {css} from '@emotion/core'

const aboutUsTranslations = require('../../translations/aboutUs.json')

const StaticSquiggle1 = ({className}) => (
    <svg
        className={className}
        width="375"
        height="232"
        viewBox="0 0 375 232"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M1.50032 182.46C61.2973 149.43 100.421 169.081 104.404 202.14C108.386 235.198 49.5203 242.806 53.5375 206.225C57.5548 169.644 125.466 95.6548 211.633 99.2325C311.536 103.381 291.408 44.6892 331.018 17.7956C339.408 9.60303 361.712 -4.55965 383.809 4.33035"
            stroke="#B3BCFF"
            strokeWidth="3"
            strokeLinecap="round"
        />
    </svg>
)

const BackgroundSquiggle = ({className}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="180"
        viewBox="0 0 1440 180"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M820.055 117.805C1080.59 163.182 1341.91 79.9914 1440 0V180H0V161.437C270.736 -8.72633 535 68.1578 820.055 117.805Z"
            fill="#1E222D"
        />
    </svg>
)

const AboutHero = ({themeStyles, lang}) => {
    const localizations = aboutUsTranslations[lang]
    const verboseLangs = ['fr', 'no', 'pt', 'sv', 'pl']
    const isVerboseLang = verboseLangs.includes(lang)
    return (
        <div
            css={css`
                margin-top: 109px;
                padding: 116px 0 0;
                width: 100%;
                background-color: ${themeStyles.about.heroBackground1};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                overflow: hidden;
                @media (${themeStyles.breakPoints.mobile}) {
                    padding-top: 53px;
                    margin-top: 76px;
                }
            `}
        >
            <StaticSquiggle1
                css={css`
                    position: absolute;
                    top: 339px;
                    right: -45px;
                    z-index: 0;
                    pointer-events: none;
                    max-width: 414px;
                    width: 100%;
                    @media (${themeStyles.breakPoints.tabletLarge}) {
                        right: -150px;
                        top: 355px;
                    }
                    @media (${themeStyles.breakPoints.tablet}) {
                        display: none;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        display: block;
                        max-width: 248px;
                        top: auto;
                        right: -133px;
                        bottom: 35px;
                    }
                `}
            />
            <h2
                css={css`
                    font-size: 88px;
                    line-height: 96px;
                    font-weight: 700;
                    color: #fbfbfd;
                    text-align: center;
                    max-width: 712px;
                    width: 100%;
                    letter-spacing: -1.76px;
                    margin-bottom: 39px;
                    position: relative;
                    padding: 0 32px;
                    z-index: 1;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 423px;
                        ${isVerboseLang
                            ? css`
                                  font-size: 50px;
                              `
                            : css`
                                  font-size: 56px;
                              `}
                        line-height: 64px;
                        letter-spacing: -1.12px;
                    }
                    @media (${themeStyles.breakPoints.mobileSmall3}) {
                        font-size: 40px;
                        line-height: 48px;
                        letter-spacing: -0.8px;
                    }
                `}
            >
                {localizations.heading1}
            </h2>
            <p
                css={css`
                    max-width: 987px;
                    width: 100%;
                    text-align: center;
                    font-size: 20px;
                    line-height: 28px;
                    font-weight: 400;
                    color: #fbfbfd;
                    position: relative;
                    z-index: 1;
                    margin-bottom: 94px;
                    padding: 0 32px;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 359px;
                        font-size: 16px;
                        line-height: 24px;
                        margin-bottom: 159px;
                    }
                `}
            >
                {localizations.copy1}
            </p>
            <BackgroundSquiggle
                css={css`
                    width: 100%;
                    height: auto;
                    z-index: 0;
                    pointer-events: none;
                    // We need this margin to eliminate a faint seam at the bottom of the background squiggle
                    margin-bottom: -2px;
                `}
            />
        </div>
    )
}

export default AboutHero
